<div class="container-fluid">
  <app-page-header
    icon="fe-user-plus"
    pretitle="Registo"
    [title]="isEdit() ? 'Editar cliente' : 'Novo cliente'"
    description="Dados de contacto do cliente. O e-mail liga o cliente aos seus chamados."
  >
    <a actions class="btn btn-outline-light" [routerLink]="['..']">
      <i class="fe fe-x me-1"></i> Cancelar
    </a>
  </app-page-header>
</div>

<div class="container-fluid">
  <form [formGroup]="form" (ngSubmit)="submit()">
    @if (error()) {
      <div class="alert alert-danger">{{ error() }}</div>
    }

    <div class="row">
      <div class="col-12 col-lg-8">
        <div class="card">
          <div class="card-body">
            <div class="row g-3">
              <div class="col-12 col-md-6">
                <label class="form-label">Nome</label>
                <input class="form-control" formControlName="name" placeholder="Nome do cliente" />
                @if (form.controls.name.touched && form.controls.name.invalid) {
                  <small class="text-danger">O nome é obrigatório.</small>
                }
              </div>
              <div class="col-12 col-md-6">
                <label class="form-label">E-mail</label>
                <input class="form-control" type="email" formControlName="email" placeholder="cliente@empresa.com" />
                @if (form.controls.email.touched && form.controls.email.invalid) {
                  <small class="text-danger">Indique um e-mail válido.</small>
                }
              </div>
              <div class="col-12 col-md-6">
                <label class="form-label">Telefone</label>
                <input class="form-control" formControlName="phone" placeholder="(opcional)" />
              </div>
              <div class="col-12 col-md-6">
                <label class="form-label">Empresa</label>
                <input class="form-control" formControlName="company" placeholder="(opcional)" />
              </div>
              <div class="col-12 col-md-6">
                <label class="form-label">Organização</label>
                <select class="form-select" formControlName="organizationId">
                  <option [ngValue]="null">— Nenhuma —</option>
                  @for (org of organizations(); track org.id) { <option [ngValue]="org.id">{{ org.name }}</option> }
                </select>
              </div>
              <div class="col-12">
                <label class="form-label">Notas</label>
                <textarea class="form-control" rows="4" formControlName="notes"
                  placeholder="Observações internas sobre o cliente (opcional)"></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>

      @if (isEdit()) {
        <div class="col-12 col-lg-4">
          <div class="card">
            <div class="card-body">
              <label class="form-label">Situação</label>
              <select class="form-select" formControlName="status">
                @for (o of statusOptions; track o.value) { <option [value]="o.value">{{ o.label }}</option> }
              </select>
              <p class="small text-muted mt-2 mb-0">Clientes inativos permanecem no histórico, mas saem das listas ativas.</p>
            </div>
          </div>
        </div>
      }
    </div>

    <div class="d-flex justify-content-end gap-2">
      <a class="btn btn-white" [routerLink]="['..']">Cancelar</a>
      <button type="submit" class="btn btn-primary" [disabled]="saving()">
        {{ saving() ? 'A guardar…' : (isEdit() ? 'Guardar alterações' : 'Criar cliente') }}
      </button>
    </div>
  </form>
</div>
